var ExternalLink16 = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" class=\"trustpilot-icon\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 2H2v12h12V8h-1v5H3V3h5V2Zm2 1h2.293L7.646 7.646l.708.708L13 3.707V6h1V2h-4v1Z\"/></svg>";

export { ExternalLink16 as default };
//# sourceMappingURL=external-link_16.svg.js.map
